/* @flow */

import { allRoles } from 'permissions/general';

import UserDetailsForm from '../forms/CreateAccount/UserDetailsForm';
import AccountNumbersForm from '../forms/CreateAccount/AccountNumbersForm';
import { AssetRequestForm } from '../forms/AssetRequestForm/AssetRequestForm';
import { RushAssetRequestForm } from '../forms/RushAssetRequestForm/RushAssetRequestForm';
import LicenseRequestForm from '../forms/LicenseRequestForm/LicenseRequestForm';

const formRoutes: Array<*> = [
  {
    path: '/email-verified',
    title: 'general:document_titles.forms.verify_details',
    component: UserDetailsForm,
    exact: true,
    permissions: allRoles,
  },
  {
    path: '/account-numbers',
    title: 'general:document_titles.forms.verify_details',
    component: AccountNumbersForm,
    exact: true,
    permissions: allRoles,
  },
  {
    path: '/asset-request',
    title: 'general:document_titles.forms.asset_request',
    component: AssetRequestForm,
    exact: true,
    permissions: allRoles,
  },
  {
    path: '/asset-request-rush',
    title: 'general:document_titles.forms.rush_asset_request',
    component: RushAssetRequestForm,
    exact: true,
    permissions: allRoles,
  },
  {
    path: '/license-request',
    title: 'general:document_titles.forms.license_request',
    component: LicenseRequestForm,
    exact: true,
    permissions: allRoles,
  },
];

export default formRoutes;
